<template>
  <v-row class="py-2" no-gutters>
    <v-col cols="12" class="px-4 py-2">
      <h3 class="pa-0">Start</h3>
    </v-col>
    <HorizontalScroller v-if="isLoading">
      <FavoriteItem :loading="true" title="Test" icon="mdi-test-tube"></FavoriteItem>
    </HorizontalScroller>
    <HorizontalScroller v-else>
      <FavoriteItem
        v-for="(item, index) in favoriteItems"
        :key="index"
        :title="item.title"
        :icon="item.icon"
        :image="item.image"
        :item="item"
        @click="clickFavoriteItem"
      ></FavoriteItem>
    </HorizontalScroller>
  </v-row>
</template>
<script>
import { firebase } from "../../main";
import FavoriteItem from "../items/FavoriteItem";
import HorizontalScroller from "../HorizontalScroller";

export default {
  data() {
    return {
      isLoading: true,
      favoriteItems: []
    };
  },
  mounted() {
    firebase
      .firestore()
      .collection("favorites").orderBy("sortorder", "asc")
      .onSnapshot(docs => {
        this.favoriteItems = [];
        docs.forEach(doc => {
          this.$set(this.favoriteItems, this.favoriteItems.length, doc.data());
        });
        this.isLoading = false;
      });
  },
  methods: {
    clickFavoriteItem(item) {
      window.open(item.url, "_blank");
    }
  },
  components: {
    FavoriteItem,
    HorizontalScroller
  }
};
</script>